import { Route, Routes } from "react-router-dom";
import OpgMainPage from "./OpgMainPage";
import AnalysesOpg from "./AnalyseOpg";

const OpgAnalyse = () => {
  return (
    <div>
      <Routes>
        <Route path="/analyses/:id" element={<AnalysesOpg />} />
        <Route path="/mainpage" element={<OpgMainPage />} />
      </Routes>
    </div>
  );
};

export default OpgAnalyse;
